<template>
  <el-container class="bizinfo container-mask flex flex-center">
    <div class="animated" :class="animate">
      <div class="close-wrap">
        <i class="close-btn" @click.self="closeBizInfo"></i>
      </div>
      <div class="biz-main">
        <!-- 选项卡 -->
        <el-tabs v-model="activeName" v-if="isReady" @tab-click="handleTabClick">
          <el-tab-pane v-for="item in allList" :name="item.id" :key="item.id">
            <span slot="label">
              <img v-if="activeName !== item.id" class="tab-icon1" :src="
                  item.img ||
                  require(`@img/select_cust_type/01person/icon_unselect${item.id}.png`)
                " />
              <img v-else class="tab-icon" :src="
                  item.active_img ||
                  require(`@img/select_cust_type/01person/icon_select${item.id}.png`)
                " />
              {{ item.name }}
            </span>
            <el-container>
              <el-main>
                <div class="para-head"><i class="para-icon"></i> 业务简介</div>
                <div class="bizIntro-text">
                  <text-box :text="item.explain"></text-box>
                </div>
                <div class="para-head" v-if="item.list.length">
                  <i class="para-icon"></i> 请确认携带以下资料
                </div>
                <el-row :gutter="20" class="grid-wrap">
                  <el-col :span="8" v-for="val in item.list" :key="val.title">
                    <div class="grid-content">
                      <header class="grid-title">{{ val.title }}</header>
                      <section class="grid-section">{{ val.name }}</section>
                    </div>
                  </el-col>
                </el-row>
              </el-main>
              <el-footer class="flex flex-middle flex-center">
                <button id="footer-btns-left" class="footer-btns-default" @click="send">
                  资料不齐
                </button>
                <button id="footer-btns-right" class="footer-btns-default btn-send" @click="checkIsTestEnv">
                  资料齐全
                </button>
              </el-footer>
            </el-container>
          </el-tab-pane>
        </el-tabs>
        <!-- 发送短信面板 -->

        <el-container v-else>
          <el-main class="send-main">
            <div class="send-img"></div>
            <div class="send-info">
              <p>抱歉您的资料未齐全</p>
              <p>您可发送资料清单到手机</p>
            </div>

            <div class="send-input">
              <el-form :inline="true" @submit.native.prevent>
                <el-form-item label="发送到手机号">
                  <el-input v-model="mobilePhone" :maxlength="11">
                    <el-button slot="append" class="keyboard-btn"></el-button>
                  </el-input>
                </el-form-item>
                <el-form-item label="验证码">
                  <el-input v-model.trim="CHECK_CODE"></el-input>
                  <img class="check-code-img" :src="checkCodeImg" alt="点击重新获取验证码" @click="getCheckCode" />
                </el-form-item>
              </el-form>
                <p class="error-msg">
                    <i v-if="errorMessage" class="el-icon-error"></i>
                    {{ errorMessage }}
                  </p>
            </div>
          </el-main>
          <el-footer class="flex flex-middle flex-center">
            <button id="not-send" class="footer-btns-default" @click="cancalSend">
              不发送
            </button>
            <button id="send-exit" class="footer-btns-default btn-send" @click="confirmSend"
              :disabled="errorMessage.length > 0 || mobilePhone.length < 11 || !CHECK_CODE">
              发送并退出
            </button>
          </el-footer>
        </el-container>
      </div>
    </div>
  </el-container>
</template>

<script>
import TextBox from "./component/TextBox";
import oppService from "../../service/opp-service";
import date from "@/tools/date.js";
export default {
  components: {
    TextBox
  },
  data () {
    return {
      activeName: "0",
      isReady: true,
      sentFlag: false,
      sending: false, //短信发送中
      countDown: {},
      countDownTimer: null,
      allList: [],
      errorMessage: "", //提示输入出错的信息
      mobilePhone: "",
      timeout: {},
      animate: "",
      checkCodeImg: "",
      CHECK_CODE: "",
      CHECK_DES: "",
      preventRequest: false
    };
  },
  props: ["busiCode", "bizInfo"],
  destroyed () {
    clearTimeout(this.timeout);
  },
  created () {
  },
  mounted () {
    let that = this;
    //异步修改class，防止渲染过快，ie不执行动画
    setTimeout(() => { this.animate = "slideInUp"; }, 0);
    //需要清除上一个业务的缓存，防止从业务准入跳过来数据有误
    this.$storage.removeLocal(this.$definecfg.PRE_MODULE_DATA_CACHE); //清除预录入模块配置缓存
    this.$storage.removeLocal(this.$definecfg.PRE_GROUP_DATA_CACHE); //清除预录入分组配置缓存

    let custInfo = this.$storage.getJsonSession(that.$definecfg.CUSTOMER_INFO);
    custInfo && typeof custInfo["MOBILE_TEL"] != "undefined" && (this.mobilePhone = custInfo.MOBILE_TEL);
    //更新客户类型
    let userType = this.bizInfo && this.bizInfo.userType || this.userType;
    //开户业务客户类型赋值
    if (this.$syscfg.isPersonOpenAcctBiz(this.busiCode)) {
      userType = "0";
    } else if (this.$syscfg.isOrgOpenAcctBiz(this.busiCode)) {
      userType = "1";
    } else if (this.$syscfg.isProOpenAcctBiz(this.busiCode)) {
      userType = "2";
    }
    //检查是否存在外部客户选项@zhaoyr
    let isExistExteral = this.bizConfig.infoList.filter(v => {
      return v.id == "exteral";
    }).length > 0 ? true : false;
    //存在外部客户选项，根据是否外部客户设置userType
    if (isExistExteral) {
      if (this.isLogin) { // 客户已登录 如外部客户则更改过滤用户类型
        this.isExteral && (userType = "exteral");
      }
    }
    //如果传了客户类型过来过滤一下
    this.allList = userType ? _.filter(this.bizConfig.infoList, function (item) {
      return item.id == userType;
    }.bind(this)) : this.bizConfig.infoList;
    //默认选择第一个用户类型，防止某些业务只有机构产品办理的会显示空白
    let defaultType = this.allList[0].id;
    this.activeName = userType || defaultType || "0";
    that.getCheckCode().then(() => {
      return oppService.getBusiDefInfo(that.busiCode).then(function (data) {
        if (_.includes(["BIAOZHUN", ""], that.qsVersionName)) {
          //add linjinbin 保存当前业务的业务基础配置到本地BUSI_DEF_INFOdefineConfig.$definecfg.QSJGDM_CONST.BIAOZHUN
          that.$storage.setSession(that.$definecfg.BUSI_DEF_INFO, data || {});
        }
        that.$storage.setSession(
          that.$definecfg.BUSI_SCOPE,
          data.BUSI_SCOPE || "1"
        );
        that.checkBizOpen();
        // that.checkSentCountDown();
      });
    });
  },
  beforeDestroy () {
    if (this.countDownTimer) clearInterval(this.countDownTimer);
    this.countDownTimer = null;
  },

  computed: {
    isTestEnv () { // 是否显示测试环境标识
      return oppService.getSysCommonParamsFromCacheObjs("SYS_ENV_TEXT") !== "生产环境";
    },
    explaninText () {
      return this.bizConfig.explain;
    },
    userType () {
      return this.$store.state.usertype;
    },
    filterName () {
      return this.activeName == 0
        ? "个人客户"
        : this.activeName == 1
          ? "机构客户"
          : this.activeName == 2
            ? "产品客户"
            : "非国投客户";
    },
    bizConfig () {
      return this.$bizcfg.getBizConfig(this.busiCode, this.userType);
    },
    isLogin () {
      return this.$store.state.isLogin;
    },
    isExteral () { // 是否为外部客户
      return this.$store.state.isExteral;
    },
    /**
     * @computed {Object} qsVersionName 券商机构名称 add linjinbin
     */
    qsVersionName () {
      return this.$bizcfg.getBizConfigName(
        this.$definecfg.QSJGDM_CONST[this.$basecfg.qsVersion]
      );
    },
    qsjgdm () {
      return this.$definecfg.QSJGDM_CONST[this.$basecfg.qsVersion];
    },
    isOrgOpenBiz () {
      return this.bizConfig.isOrgOpenBiz;
    }
  },
  methods: {
    handleTabClick (tab, ent) {
      let active = tab.name;

      //点击切换先不要更新userType
    },
    closeBizInfo () {
      //清除业务名称的缓存
      this.$storage.removeSession(this.$definecfg.BUSI_NAME);
      this.animate = "slideOutDown";
      setTimeout(() => {
        this.$emit("close");
      }, 400);
    },
    sentMessageLogic (value, userTypeName) {
      //value 为手机号码
      //从bizConfig里面取回要发送的内容
      let messageList = this.bizConfig.infoList;
      let message = []; //取出整个客户的信息 要添加办理的业务
      let menuName = this.$storage.getSession(this.$definecfg.BUSI_NAME);
      let messageString =
        "尊敬的客户，" + this.filterName + "办理" + menuName + "业务所需材料清单如下:        ";
      //从bizConfig里面取回要发送的信息
      message = messageList.filter(function (value) {
        if (value.id == userTypeName) {
          return value;
        }
      });

      let flag = 0;
      let commonMessage = message[0].list;
      _.each(commonMessage, function (value) {
        flag++;
        messageString += flag + "." + value.title + "-" + value.name;
      });
      messageString += "        如有疑问可咨询营业网点工作人员或拨打客服咨询热线95517。";
      consoleLog(messageString);
      if (value in this.countDown && this.countDown[value] > 0) {
        this.alert("您的操作过于频繁，请稍后再试！");
        return;
      }

      this.myLoading("短信发送中");
      this.sentSMS(value, messageString)
        .then(res => {
          this.myLoading({ showLoading: false });
          let flag = _.get(res, "Data[0].flag");
          if (flag === "0") {
            this.errorMessage = res.Data[0].msg;
            this.CHECK_CODE = "";
            return this.getCheckCode();
          } else {
            consoleLog(value + " " + res.Data[0].SEND_MSG);
            this.countDown[value] = 30; // 同一号码发送时间间隔30s
            this.alert({
              messageText: "短信发送成功",
              confirmedAction: function () {
                this.closeBizInfo();
              }.bind(this)
            });
          }
        })
        .catch(err => {
          this.myLoading({ showLoading: false });
          consoleLog(err);
        });
    },
    send () {
      this.isReady = false;

    },
    cancalSend () {
      this.isReady = true;
    },
    confirmSend () {
      // 发送并退出
      this.sentMessageLogic(this.mobilePhone, this.activeName);
    },
    checkBizOpen () {
      if (!this.bizConfig.open && !_.startsWith(this.busiCode, "P")) {
        this.alert({
          messageText: "此业务正在优化中，敬请期待!",
          msg_icon: "wran",
          confirmedAction: () => {
            this.$router.replace("/home");
          }
        });
      }
    },
    checkSentCountDown () {
      this.countDownTimer = setInterval(() => {
        for (let key in this.countDown) {
          if (this.countDown[key] <= 1) delete this.countDown[key];
          else this.countDown[key] -= 1;
        }
      }, 1000);
    },
    sentSMS: function (mobile, content) {
      return this.$syscfg.K_Request("W0000171", {
        MOBILE: mobile,
        CONTENT: content,
        CHECK_CODE: this.CHECK_CODE,
        CHECK_DES: this.CHECK_DES
      });
    },
    // clickCheckCode: _.debounce(function () {
    //   this.getCheckCode();
    // }, 1000),
    // 获取验证码
    getCheckCode () {
      let that = this;
      if (that.preventRequest) {
        return;
      }
      that.CHECK_CODE = ""; // 清除输入验证码
      that.preventRequest = true;
      return new Promise((resolve, reject) => {
        that.$syscfg.K_Request("W0000346").then((res) => {
          that.checkCodeImg = "data:image/jpg;base64," + res.Data[0].CHECK_CODE_IMG;
          that.CHECK_DES = res.Data[0].CHECK_DES;
          resolve();
          that.preventRequest = false;
        }).catch((err) => {
          that.preventRequest = false;
          resolve();
        });
      });
    },
    checkIsTestEnv () {
      let that = this;
      if (that.isTestEnv) {
        that.showTips({
          ownClass: "test-env-remind",
          tips: [`<div> 您好！当前系统为非生产环境，不能正常办理业务，请您在系统恢复后，前来办理业务，由此带来的不便敬请谅解。<p>国投证券</p><p>${date.formatDate(new Date(), "yyyy年MM月dd日")}</p></div>`],
          title: "尊敬的投资者",
          noPlayVoice: true,
          confirmedAction: function () {
            that.beReady();
          },
        });
      } else {
        that.beReady();
      }
    },
    beReady () {
      let that = this;
      let userInfo = that.$storage.getJsonSession(that.$definecfg.USER_INFO);
      that.myLoading("正在检查当前业务&请稍候...");
      if (!that.busiCode) {
        consoleLog("业务代码不能为空");
        that.confirm({
          messageText: "业务代码不能为空,请重新进入!",
          msg_icon: "wran",
          confirmedAction: () => {
            if (that.isLogin) {
              that.$router.push({ path: "/homeCustomer" });
            } else {
              that.$router.push({ path: "/home" });
            }
          }
        });
        return;
      }
      //如果有传bizInfo原型 则点击资料齐全就更新业务代码和业务名称
      that.bizInfo && that.bizInfo.busiCode && that.$store.commit(that.$types.UPDATE_BUSI_CODE, that.bizInfo.busiCode);
      that.bizInfo && that.bizInfo.menuName && that.$storage.setSession(that.$definecfg.BUSI_NAME, that.bizInfo.menuName);
      //点击资料齐全再更新客户类型
      !that.isLogin && that.$store.commit(that.$types.UPDATE_USER_TYPE, that.activeName);
      // that.$emit("beReady");
      //点击资料齐全更新是否外部客户
      if (that.activeName == "exteral") {
        !that.isLogin && that.$store.commit(that.$types.UPDATE_USER_TYPE, "0"); // 为之后获取系统公参设置为0
        that.$store.commit(that.$types.UPDATE_IS_EXTERAL, true);
      } else {
        that.$store.commit(that.$types.UPDATE_IS_EXTERAL, false);
      }
      // if(that.busiCode == "V0149"){
      //   //表单打印 直接进入oa登陆
      //   that.$router.replace({ 
      //     name: "oaLogin",
      //     params: { 
      //       busiCode: "V0149",
      //       userType: that.userType ,styleType: {
      //         userPostName: "业务运营岗",
      //         allowUserPost: "111,116",
      //       } } });
      //   return;
      // }
      return Promise.all([
        ["V0020", "V0137","V0172"].includes(that.busiCode) ? that.$syscfg.K_Request("F0000000", {
          SERVICE_CODE: "Y1000094",
          ORG_CODE: userInfo.ORG_CODE,
        }) : "",
      ]).then(res => {
        if (res[0] != "") {
          if (res[0].Code == "0") {
            if (res[0].Data[0] && res[0].Data[0].IS_GGQQ == "0") {
              that.alert({
                messageText: "当前营业部没有开立期权账户的资格，详情请咨询现场工作人员！",
                confirmButtonText: "确定",
                confirmedAction: function () {
                  that.closeBizInfo();
                }
              }
              );
              return;
            }
          } else {
            that.alert({
              messageText: res[0].Msg,
              confirmButtonText: "确定",
              confirmedAction: function () {
                that.closeBizInfo();
              }
            });
            return;
          }
        }
        //获取当前业务是否依赖于外部系统
        return that.$syscfg.K_Request("W0000345", {
          BUSI_CODE: that.busiCode,
        }).then(function (data) {
          that.myLoading({ showLoading: false });
          //1 禁止办理 2 营业厅稍作等待 3等待下一个工作日
          let type = data.Data[0].SUBMIT_TYPE;
          if (type == 1) {
            // that.$emit("beReady");
            that.alert(`${data.Data[0].REASON}`);
            return;
          }
          if(that.busiCode == "V0149"){
            //表单打印 直接进入oa登陆
            that.$router.replace({ 
              name: "oaLogin",
              params: { 
                busiCode: "V0149",
                userType: that.userType ,styleType: {
                  userPostName: "业务运营岗",
                  allowUserPost: "111,116",
                } } });
            return;
          }
          if (that.isLogin) {
            // 外部客户已登录状态，直接进入到业务
            if (that.isExteral) {
              that.$router.replace({
                name: "customerCheck",
                params: { busiCode: that.busiCode, userType: that.userType }
              });
              return;
            }
            that.$router.replace({
              name: "customerLogin",
              params: { setCurrentStep: "enterPassword" }
            });
          } else {
            if (that.busiCode == "Z0035" && that.userType != "0") {
              that.$router.replace({
                name: "customerCheck",
                params: { busiCode: that.busiCode, userType: that.userType }
              }); // 机构，产品开户跳过读卡
            } else if (that.$basecfg.platform == "vtm") {
              if (that.isExteral || that.userType == "0") {
                if (that.$syscfg.isPersonOpenAcctBiz(that.busiCode)) {
                  that.$router.replace({ name: "readCard", params: { isCustomerRecog: true } });
                } else {
                  that.$router.replace("/readCard");
                }
              } else {
                if (that.$syscfg.isOpenAcctBiz(that.busiCode)) {
                  that.forwardTonative();
                } else {
                  that.$router.replace("/customerLogin");
                }
              }
            } else {
              // 移动端
              that.forwardTonative();
            }
          }
        }).catch(err => {
          consoleLog("获取当前业务是否依赖于外部系统", err);
          that.myLoading({ showLoading: false });
        });
      });
    },
    forwardTonative () {
      if (this.$syscfg.isPersonOpenAcctBiz(this.busiCode)) {
        this.$router.replace({ name: "readCard", params: { isCustomerRecog: true } });
        return;
      } else if (this.$syscfg.isOrgOpenAcctBiz(this.busiCode)) {
        // 开户 直接跳三要素填写
        this.$router.replace({ name: "customerRecognition" });
        return;
      } else if (this.$syscfg.isProOpenAcctBiz(this.busiCode)) {
        // 开户 直接跳三要素填写
        this.$router.replace({ name: "customerRecognition" });
        return;
      }
      this.$router.replace({ path: "/customerLogin" });
    }
  },
  watch: {
    mobilePhone () {
      let flag = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])[0-9]{8}$/.test(
        this.mobilePhone
      );
      if (!flag) {
        this.errorMessage = "请输入正确的手机号码";
      } else {
        this.errorMessage = "";
      }
      if (this.mobilePhone == "") {
        this.errorMessage = "";
      }
    },
    CHECK_CODE () {
      if (this.errorMessage == "验证码输入错误" && this.CHECK_CODE) {
        this.errorMessage = "";
      }
    }
  }
};
</script>

<style lang="less">
@mainBack: #ec9228;

.container-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  z-index: 2018;
  background-color: rgba(0, 0, 0, 0.8);
  flex-direction: row !important;
  align-items: flex-end;
  .close-wrap {
    position: relative;
    width: 1300px;
    height: 90px;
    .close-btn {
      position: absolute;
      right: 0;
      display: block;
      width: 70px;
      height: 70px;
      background: url("~@img/select_cust_type/01person/icon_guanbi.png");
    }
  }
  .biz-main {
    width: 1300px;
    height: 920px;
    border-radius: 4px;
    background-color: #ffffff;
    overflow: hidden;
    .el-tabs {
      .el-tabs__header {
        background: linear-gradient(
          0deg,
          rgba(231, 235, 242, 1),
          rgba(250, 251, 252, 1)
        );
        border-radius: 4px 4px 0px 0px;
      }
      .el-tabs__nav-wrap {
        background: url("~@img/select_cust_type/01person/pic_dianzhen.png")
          no-repeat right;
        height: 110px;
        .el-tabs__nav {
          width: 1080px;
          height: 48px;
          margin: 0 110px;
          padding: 32px 0px 30px;
          display: flex;
          align-items: baseline;
          .el-tabs__active-bar {
            width: 130px !important;
            height: 4px;
            background-color: @mainBack;
          }
          .el-tabs__item {
            // width: 200px;
            padding-right: 100px;
            font-size: 32px;
            color: #808992;
            font-weight: bold;
            text-align: center;
            // color: @mainBack;
            > span {
              position: relative;
              display: flex;
              align-items: center;
              justify-content: space-between;
              min-width: 130px;
              padding-left: 45px;
              line-height: 1;
              box-sizing: border-box;
              .tab-icon,
              .tab-icon1 {
                position: absolute;
                bottom: 0;
                left: 0;
              }
              .tab-icon {
                width: 44px;
                height: 44px;
              }
              .tab-icon1 {
                width: 35px;
                height: 35px;
              }
            }
          }
          .is-active {
            font-size: 40px;
            color: @mainBack;
          }
        }
        &::after {
          height: 1px;
          background-color: @mainBack;
        }
      }
      .el-tabs__content {
        // padding: 0 60px;
        .el-main {
          padding: 0 70px;
          height: 670px;
          overflow-y: scroll;
          .para-head {
            width: 100%;
            margin: 40px 0 20px;
            color: #000;
            line-height: 1;
            font-weight: bold;
            font-size: 24px;
            .para-icon {
              display: inline-block;
              width: 24px;
              height: 18px;
              margin-right: 4px;
              background: url("~@img/select_cust_type/01person/icon_biaoti.png")
                no-repeat;
            }
          }
          .bizIntro-text {
            padding: 0 38px;
          }
          .grid-wrap {
            padding: 0px 38px 0;
            .grid-content {
              box-sizing: border-box;
              height: 164px;
              overflow: hidden;
              overflow-y: auto;
              padding: 20px 26px;
              margin-bottom: 20px;
              background: #f3f4f5;
              border: 1px solid rgba(178, 185, 198, 1);
              border-radius: 4px;
              -ms-scroll-chaining: chained;
              -ms-overflow-style: none;
              -ms-content-zooming: zoom;
              -ms-scroll-rails: none;
              -ms-content-zoom-limit-min: 100%;
              -ms-content-zoom-limit-max: 500%;
              -ms-scroll-snap-type: proximity;
              -ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
              -ms-overflow-style: none;
              overflow: auto;
              .grid-title {
                font-size: 24px;
                font-weight: 500;
                color: rgba(35, 35, 35, 1);
                line-height: 30px;
              }
              .grid-section {
                margin-top: 16px;
                font-size: 20px;
                font-weight: 400;
                color: rgba(128, 137, 146, 1);
                line-height: 28px;
              }
            }
          }
        }
      }
    }
    .send-main {
      display: flex;
      align-items: center;
      flex-direction: column;
      box-sizing: border-box;
      height: 790px;
      padding-top: 190px;
      .send-img {
        width: 496px;
        height: 212px;
        background: url("~@img/select_cust_type/04sms/pic_ziliaobuqi.png");
      }
      .send-info {
        color: #000;
        font-size: 40px;
        font-weight: 500;
        text-align: center;
        line-height: 54px;
      }
      .send-input {
        margin-top: 130px;
        .el-form {
          display: flex;
          .el-form-item {
            display: flex;
            img {
                flex: 0 0 160px;
                height: 65px;
            }
            .el-form-item__content {
              display: flex;
            }
          }
        }
        .el-form-item__label {
          height: 66px;
          padding-right: 20px;
          line-height: 66px;
          font-size: 24px;
          font-weight: 500;
          color: #343434;
        }
        .el-input__inner {
          width: 230px;
          height: 66px;
          color: #232323;
          font-size: 24px;
          font-weight: 500;
          border: 2px solid rgba(161, 166, 185, 1);
          box-shadow: inset 0px 3px 2px 0px rgba(34, 49, 89, 0.1);
        }
        .el-input-group__append {
          background: linear-gradient(
            180deg,
            rgba(254, 254, 254, 1),
            rgba(255, 255, 255, 1),
            rgba(229, 232, 236, 1)
          );
          border: 2px solid rgba(161, 166, 185, 1);
          border-left: none;
          border-radius: 0px 4px 4px 0px;
        }
        .keyboard-btn {
          width: 66px;
          height: 66px;
          background: url("~@img/select_cust_type/04sms/icon_xiugai.png")
            no-repeat center center;
        }
      }
    }
    .el-footer {
      height: 130px !important;
      padding: 25px 0;
      border-top: 1px solid #b2b9c6;
      .footer-btns-default {
        width: 220px;
        height: 80px;
        border: 2px solid #5172f6;
        border-radius: 4px;
        font-size: 32px;
        font-weight: 500;
        color: #3c5ce2;
        background-color: #fff;
        &.btn-send {
          margin-left: 40px;
          color: #fff;
          border: none;
          background: linear-gradient(
            45deg,
            rgba(53, 86, 221, 1),
            rgba(70, 103, 233, 1)
          );
          &[disabled="disabled"] {
            background: linear-gradient(
              45deg,
              rgba(182, 194, 243, 1),
              rgba(188, 200, 247, 1)
            );
          }
        }
      }
    }
    .extraTip {
      display: none;
    }
  }
}

p {
  margin: 0;
  padding: 0;
}
.error-msg {
  height: 20px;
  font-size: 24px;
  font-weight: 500;
  color: #e82d2d;
}
@keyframes rotation {
  from {
    -webkit-transform: none;
    -ms-transform: none;
  }
  to {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/bizInfo/bizInfo.vue